module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-700.7f0bc4d2.woff";